import { render } from "./ButtonAddCartComponent.vue?vue&type=template&id=1a470e21"
import script from "./ButtonAddCartComponent.vue?vue&type=script&lang=js"
export * from "./ButtonAddCartComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__